
import { Component, Vue } from 'vue-property-decorator';
import {inspectionOrderApi} from "@/api/inspection";
import {IPage} from "@/js/page";
import {userApi} from "@/api/organization";
import SetTableColumns from "@/components/SetTableColumns.vue";
import InstrumentList from "@/components/InstrumentList.vue";
import InstrumentSubmit from "@/components/InstrumentSubmit.vue";
import ImportPreview from "@/components/ImportPreview.vue";

@Component({
  name: "technicalList",
  components: {ImportPreview, SetTableColumns, InstrumentList, InstrumentSubmit}
})
export default class Home extends Vue {
  importPreviewDialog = false;
  listParam: IPage = {
    size: 10,
    current: 1,
  };
  modeType = "0";
  listData = [];
  listTotal = 0;
  listTotal0 = "";
  listTotal1 = "";
  allSelected = [];
  memberList = [] as any;  //成员列表
  setDialog = false;
  userId = "";
  loading = false;
  showForm = false;
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  tabCol = [];
  propParams = {
    initiatorMechanismName: "", //报检单位
    initiatorName: "", //报检人
    startDate: "", // 报检日期开始时间
    endDate: "", //报检日期结束时间
  } as any
  tableKey = 0;

  created(){
    const route = this.$route;
    const q = JSON.parse(JSON.stringify(route.query));
    if(q.modeType){
      this.modeType = q.modeType;
    }
    if(q.size){
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
    for(const f in this.propParams){
      if(q[f]) this.propParams[f] = q[f];
    }

    //获取登录人名称
    const userData = this.$store.state.AuthedUser;
    console.log(userData)
    this.getConfig();
  }
  activated(){
    if (this.$route.meta && !this.$route.meta.isBack) {
      this.listParam.current = 1;
    }
    this.tableClearSelect();
    this.getTaskNumber();
    if(this.modeType == "3" || this.modeType == "4"){
      const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
      $instrumentList.list();
    }
  }
  tableClearSelect(){
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }
  getConfig() {
    userApi.getUserConfig({name: "technicalPageSize"}).then(r => {
      if (r.data.result == 0) {
        const rData = r.data.data;
        if (rData) {
          this.listParam.size = Number(rData.config);
        }
        this.getTaskNumber();
      }
    })
  }
  getTaskNumber(){
    this.list("0");
    this.list("1");
    if(this.modeType == "2"){
      this.list("2");
    }
  }
  instrumentParam(data: any){
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q, data);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    // if(JSON.stringify(q) != JSON.stringify(route.query)){
    //   this.$router.replace({name:route.name!,query: q})
    // }
    if(q.size){
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
  }
  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(()=>{
      let $table = this.$refs.table as HTMLFormElement;
      if($table){
        $table.doLayout();
      }
      this.tableKey = Math.random();
    })
  }
  indexMethod(index: any) {
    return (this.listParam.current-1)*this.listParam.size+index+1;
  }
  handleClick(){
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
    const instrumentSubmit = this.$refs.instrumentSubmit as HTMLFormElement;
    if(instrumentSubmit){
      instrumentSubmit.reset();
    }
    this.refresh();
  }
  list(modeType: string = this.modeType){
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q,{modeType: this.modeType}, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    if(modeType == "3" || modeType == "4") return;
    // if(JSON.stringify(q) != JSON.stringify(route.query)){
    //   this.$router.replace({name:route.name!,query: q})
    // }

    inspectionOrderApi.listInspectionOrderApply({
      mode: 2,
      modeType: modeType?modeType:this.modeType,
      ...this.listParam,
      ...this.propParams
    }).then(r=>{
      if(r.data.result == 0){
        const rData = r.data.data;
        if(this.modeType == modeType){
          this.listData = rData.records;
          this.listTotal = rData.total;
        }
        if(modeType == "0"){
          this.listTotal0 = rData.total;
        }else if(modeType == "1"){
          this.listTotal1 = rData.total;
        }
        this.$nextTick(()=>{
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.doLayout();
          }
        })
      }
    })
  }
  //上报检定器具数据
  onReportInstrument(){
    const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
    const dataArr = $instrumentList.getCheckData();
    if(dataArr.length == 0){
      this.$message.error("请先勾选一条数据");
      return;
    }
    let data = dataArr.filter((d: any) => d.checkResult.value === 0);
    if(data.length > 0){
      const names = data.flatMap((e: any) => e.name).join("，");
      this.$message.error("您选择的 【" + names+ "】未检定完成，不能上报！");
      return;
    }
    data = dataArr.filter((d: any) => d.reportStatus.value === 1);
    if(data.length > 0){
      const names = data.flatMap((e: any) => e.name).join("，");
      this.$message.error("您选择的 【" + names+ "】已上报，无需再次上报！");
      return;
    }
    this.$confirm('确定要上报检定器具名称为:  ' + dataArr.flatMap((e: any) => e.name).join("，") + '？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      this.reportInstrument(dataArr);
    });
  }
  reportInstrument(dataArr: any){
    this.loading = true;
    inspectionOrderApi.instrumentReport({"orderInstrumentsIds": dataArr.flatMap((e:any)=>e.id).join(",")}).then((r: any) => {
      if(r.data.result === 0){
        this.$message.success("上报成功!");
        const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
        if($instrumentList){
          $instrumentList.handleClick();
        }
      }
      this.loading = false;
    });
  }
  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
    userApi.updateUserConfig({name: "technicalPageSize", config: val})
  }
  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.list();
  }
  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }
  //打开处理人列表
  appointBtn(){
    if(this.allSelected.length == 0){
      this.$message.error("请先勾选任务");
      return;
    }
    this.userId = "";
    userApi.listHaveRightUser({
      right: "check_order_user"
    }).then(r=>{
      if(r.data.result == 0){
        const rData = r.data.data;
        this.memberList = rData;
        if(this.memberList.length > 0){
          this.setDialog = true;
        }else{
          this.$message.warning("你单位还没有个人注册或人员绑定！");
        }
      }
    })

  }
  saveBtn(){
    if(!this.userId){
      this.$message.error("请选择一个处理人");
      return;
    }
    const person = {
      orderApplyIds: this.allSelected.flatMap((e:any)=>e.id).join(","),
      userId: this.userId,
      userName: this.memberList.find((e:any)=>e.id == this.userId).name
    }
    inspectionOrderApi.settingInspectionOrderApply(person).then(r=>{
      if(r.data.result == 0){
        this.$message.success("设置成功");
        this.setDialog = false;
        this.handleClick();
        this.getTaskNumber();
      }
    })
  }
  //退回
  returnBtn(row: any){
    this.$confirm("确认要退回到业务大厅吗?","确认操作",{type:"warning"})
      .then(()=>{
        inspectionOrderApi.returnInspectionOrderApply({ids: row.id, modeType: 0}).then(r => {
          if(r.data.result === 0){
            this.$message("退回成功");
            this.handleClick();
            this.getTaskNumber();
          }
        })
      })
  }
  //从无匹配状态 退回到 待受理状态
  returnBtn2(row: any){
    this.$confirm("确定要退回给使用单位吗?","确认操作",{type:"warning"}).then(()=>{
      inspectionOrderApi.returnInspectionOrderApply({ids: row.id, modeType: 1}).then(r => {
        if(r.data.result === 0){
          this.$message("退回成功");
          this.handleClick();
          this.getTaskNumber();
        }
      })
    });
  }

  //跳转详情 type 0编辑  1查看
  toDetail(row: any, type: number){
    this.$router.push("/qj/technical/detail/"+row.id+"/"+row.orderId+"/"+type);
  }
  refresh() {
    this.listParam.current = 1;
    this.list();
  }

  //获取勾选数据 0办理 1查看 2退回
  getCheck(type: number){
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (dataArr.length > 1 ) {
      this.$message.error("只能勾选一条");
      return;
    }
    const checkData = dataArr[0];
    if(type===0){
      //如果是无匹配的订单 跳转页面是 生成PDF的页面
      if(checkData.status.name == 'NoMatch' || checkData.status.name == 'WaitProve'){
        this.$router.push("/qj/technical/noMatchDetail/" + checkData.id);
      }else{
        this.toDetail(checkData, type);
      }
    }else if(type === 1){
      this.toDetail(checkData, type);
    }else if(type === 2){
      //无匹配的订单 无法进行退回操作
      // if(checkData.status.name == 'NoMatch' || checkData.status.name == 'WaitProve'){
      //   this.$message.error("无匹配的订单！无法进行退回操作");
      //   return;
      // }
      this.returnBtn(checkData);
    }else if(type === 3){
      this.returnBtn2(checkData);
    }
  }
  //获取器具的勾选 0办理 1查看
  instrumentExamineChange = false;
  instrumentCheck(type: number){
    const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
    const dataArr = $instrumentList.getCheckData();
    if(dataArr.length == 0){
      this.$message.error("请先勾选");
      return;
    }
    if (dataArr.length > 1 ) {
      this.$message.error("只能勾选一条");
      return;
    }
    if(type == 0){
      // $instrumentList.checkAdd(dataArr[0].id);
      $instrumentList.showExamineList(dataArr[0], true);
      this.instrumentExamineChange = true;
    }else{
      // $instrumentList.detail(dataArr[0]);
      $instrumentList.showExamineList(dataArr[0], true);
      this.instrumentExamineChange = false;
    }
  }

  //器具列表增加查询条件
  dialogForm = {} as any; //器具列表搜索条件
  refreshInstrument(e:any) {
    this.dialogForm = JSON.parse(JSON.stringify(e));
  }

//  批量导出器具 导入结果****************************************
  importPreviewData = [];
  importPreviewShowType = 0;  //0导出  1导入
  batchExport(){
    const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
    const dataArr = $instrumentList.getCheckData();
    if(dataArr.length == 0){
      this.$message.error("请先勾选");
      return;
    }
    this.importPreviewData = dataArr;
    this.importPreviewShowType = 0;
    this.importPreviewDialog = true;
  }
  batchImport(){
    console.log("批量导入");
    this.importPreviewShowType = 1;
    this.importPreviewDialog = true;
  }
  clostDialog(){
    this.importPreviewDialog = false;
    if(this.modeType == "3"){
      const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
      $instrumentList.list();
    }
  }
  //  批量导出器具 导入结果 end****************************************
}
